import { z } from 'zod';

export enum LicenseStatus {
  Active = 0,
  Transferred = 1,
  Reset = 2,
  Unknown = 3,
  Deactivated = 4,
  Deleted = 5,
}

export const completeSystemLicenseSchema = z.object({
  licensingInfoId: z.string().nullish(),
  licenseId: z.string(),
  systemId: z.string(),
  product: z.string().nullish(),
  lastReportedAt: z.string().nullish(),
  createdAt: z.string().nullish(),
  trialEndedAt: z.string().nullish(),
  customerId: z.string().nullish(),
  serialNumber: z.string().nullish(),
  features: z.string().nullish(),
  machineCount: z.number().nullish(),
  isTrainingLicense: z.boolean().nullish(),
  status: z.nativeEnum(LicenseStatus),
  hasProductionLicense: z.boolean().nullish(),
  hasTrainingLicense: z.boolean().nullish(),
  isAgentReported: z.boolean(),
});
export type CompleteSystemLicenseDto = z.infer<typeof completeSystemLicenseSchema>;

export const listSystemLicensesResponseSchema = z.object({
  systemLicenses: z.array(completeSystemLicenseSchema),
});
export type ListSystemLicensesResponse = z.infer<typeof listSystemLicensesResponseSchema>;

export interface ListSystemLicensesQuery {
  systemId: string;
}
